import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box, Image, Link, Text } from '@theme-ui/components';

import { getButtonStyles } from '@app/components/Button';
import Card from '@app/components/Card';
import type { AppTheme } from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

import nativeAccess1x from '../assets/native-access-1x.png';
import nativeAccess2x from '../assets/native-access-2x.png';
import messages from '../Success.messages';
import {
  neutralCardStyles,
  nextStepImageStyles,
  NextStepsGrid,
  nextStepsRowStyles,
} from '../Success.styles';

const NativeAccess = ({ productName }: { productName: string }) => {
  const { language = 'en' } = useParams<{ language?: string }>();
  const nativeAccessLink = `https://www.native-instruments.com/${language}/specials/native-access-2/`;

  return (
    <Card css={neutralCardStyles} data-testid="native-access">
      <NextStepsGrid>
        <Box sx={{ textAlign: 'center' }} px={[20]} css={nextStepsRowStyles}>
          <Text sx={{ fontSize: rem(20), fontWeight: 500 }}>
            {productName ? (
              <span data-testid="native-access-product-title">
                <FormattedMessage
                  {...messages.getViaNativeTitle}
                  values={{ product: productName }}
                />
              </span>
            ) : (
              <span data-testid="native-access-generic-title">
                <FormattedMessage {...messages.getNativeAccess} />
              </span>
            )}
          </Text>

          <Box
            sx={{
              marginTop: rem(20),
              marginBottom: rem(20),
              fontSize: rem(14),
            }}
          >
            <FormattedMessage {...messages.getViaNativeDescription} />
          </Box>

          <Link
            href={nativeAccessLink}
            data-testid="native-access-link"
            css={(theme: AppTheme) =>
              getButtonStyles({ type: 'secondary', theme })
            }
          >
            <FormattedMessage {...messages.learnMore} />
          </Link>
        </Box>

        <Image
          srcSet={`
             ${nativeAccess1x} 1x,
             ${nativeAccess2x} 2x`}
          src={nativeAccess1x}
          alt=""
          css={nextStepImageStyles}
          data-testid="native-access-image"
        />
      </NextStepsGrid>
    </Card>
  );
};

export default NativeAccess;
